export default __webpack_public_path__ + "alarmStatus-armed-home.79c00fa4.png";